export default "__VITE_ASSET__4J$lp3cV__"